import { Navigate, useLocation } from 'react-router-dom'

type InteractionsView = 'likes' | 'blocks' | 'conversations'

interface RedirectToUserInteractionsProps {
  view: InteractionsView
}

const RedirectToUserInteractions = ({ view }: RedirectToUserInteractionsProps) => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  params.set('view', view)

  return <Navigate to={`/admin/user-interactions?${params.toString()}`} replace />
}

export default RedirectToUserInteractions
